export const summaryTaskPage = {
    after: ['После', 'After'],
    before: ['До', 'Before'],
    bio: ['Био', 'Bio'],
    delay: ['Задержка', 'Delay'],
    dhc: ['Пассажиры по заданию', 'Dead head crew'],
    distance: ['Дистанция', 'Distance'],
    end: ['Конец', 'End'],
    expand: ['Развернуть', 'Expand'],
    flight: ['Рейс №', 'Flight #'],
    indep: ['Самост', 'Indep'],
    landings: ['Посадки', 'Landings'],
    night: ['Ночь', 'Night'],
    parking: ['Стоянка', 'Parking'],
    pf: ['PF', 'PF'],
    resetEditedLeg: ['Сбросить изменения участка', 'Reset for edited leg'],
    rest: ['Отдых', 'Rest'],
    start: ['Начало', 'Start'],
    takeOff: ['Взлёт', 'Take Off'],
    task: ['Задание', 'Task'],
    total: ['Всего', 'Total'],
};
